import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const Login = () => import('../views/Login.vue')
const AdminLayout = () => import('../layouts/AdminLayout.vue')
const Dashboard = () => import('../views/Dashboard.vue')
const UserManage = () => import('../views/system/UserManage.vue')
const RoleManage = () => import('../views/system/RoleManage.vue')
const MenuManage = () => import('../views/system/MenuManage.vue')
const DeptManage = () => import('../views/system/DeptManage.vue')
const PostManage = () => import('../views/system/PostManage.vue')
const DictManage = () => import('../views/system/DictManage.vue')
const AnnouncementManage = () => import('../views/system/announcement/index.vue')
const OnlineUsers = () => import('../views/monitor/OnlineUsers.vue')
const ServerMonitor = () => import('../views/monitor/ServerMonitor.vue')
const CacheMonitor = () => import('../views/monitor/CacheMonitor.vue')
const DruidMonitor = () => import('../views/monitor/DruidMonitor.vue')
const CaseManage = () => import('../views/content/case/index.vue')
const PartnerManage = () => import('../views/content/partner/index.vue')
const BusinessCardManage = () => import('../views/content/business-card/index.vue')
const IntentManage = () => import('../views/content/intent/index.vue')
const NewsManage = () => import('../views/content/news/index.vue')
const CaseCategoryManage = () => import('../views/content/case-category/index.vue')
const TrustSectionManage = () => import('../views/content/trust-section/index.vue')
const SiteConfigManage = () => import('../views/content/site-config/index.vue')
const HomeBannerManage = () => import('../views/content/home-banner/index.vue')
const AboutPageManage = () => import('../views/content/about-page/index.vue')
const ChatFaqManage = () => import('../views/chat/faq/index.vue')
const ChatSessionManage = () => import('../views/chat/session/index.vue')
const ChatLeadManage = () => import('../views/chat/lead/index.vue')
const ChatSettingsManage = () => import('../views/chat/settings/index.vue')
const ChatUnmatchedManage = () => import('../views/chat/unmatched/index.vue')
const ChatAgentDesk = () => import('../views/chat/agent/index.vue')
const ChatIntentRuleManage = () => import('../views/chat/intent-rule/index.vue')
const ExhibitorExhibitionManage = () => import('../views/exhibitor/exhibition/index.vue')
const ExhibitorListManage = () => import('../views/exhibitor/list/index.vue')
const ExhibitorDetail = () => import('../views/exhibitor/detail/index.vue')
const ExhibitorCommunicationManage = () => import('../views/exhibitor/communication/index.vue')
const MpHomeVideoManage = () => import('../views/mp/home/video/index.vue')
const MpHomeServiceScope = () => import('../views/mp/home/service-scope/index.vue')
const MpHomeNews = () => import('../views/mp/home/news/index.vue')
const MpHomeClientsManage = () => import('../views/mp/home/clients/index.vue')

const APP_TITLE = '客户管理系统'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { public: true },
    },
    {
      path: '/',
      component: AdminLayout,
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: { name: 'dashboard' } },
        { path: 'dashboard', name: 'dashboard', component: Dashboard, meta: { title: '工作台', affix: true } },
        {
          path: 'account/profile',
          name: 'account-profile',
          component: () => import('../views/account/Profile.vue'),
          meta: { title: '个人资料' },
        },
        {
          path: 'account/messages',
          name: 'account-messages',
          component: () => import('../views/account/Messages.vue'),
          meta: { title: '消息中心' },
        },
        { path: 'system/user', name: 'system-user', component: UserManage, meta: { title: '用户管理' } },
        { path: 'system/role', name: 'system-role', component: RoleManage, meta: { title: '角色管理' } },
        { path: 'system/menu', name: 'system-menu', component: MenuManage, meta: { title: '菜单管理' } },
        { path: 'system/dept', name: 'system-dept', component: DeptManage, meta: { title: '部门管理' } },
        { path: 'system/post', name: 'system-post', component: PostManage, meta: { title: '岗位管理' } },
        { path: 'system/dict', name: 'system-dict', component: DictManage, meta: { title: '字典管理' } },
        {
          path: 'system/announcement',
          name: 'system-announcement',
          component: AnnouncementManage,
          meta: { title: '公告管理' },
        },
        {
          path: 'system/dict/data/:dictType',
          name: 'system-dict-data',
          component: () => import('../views/system/DictData.vue'),
          meta: { title: '字典数据' },
        },
        { path: 'monitor/online', name: 'monitor-online', component: OnlineUsers, meta: { title: '在线用户' } },
        { path: 'monitor/server', name: 'monitor-server', component: ServerMonitor, meta: { title: '服务监控' } },
        { path: 'monitor/cache', name: 'monitor-cache', component: CacheMonitor, meta: { title: '缓存监控' } },
        { path: 'monitor/druid', name: 'monitor-druid', component: DruidMonitor, meta: { title: '连接池监控' } },
        { path: 'content/case', name: 'content-case', component: CaseManage, meta: { title: '案例管理' } },
        { path: 'content/partner', name: 'content-partner', component: PartnerManage, meta: { title: '合作伙伴' } },
        {
          path: 'content/business-card',
          name: 'content-business-card',
          component: BusinessCardManage,
          meta: { title: '名片管理' },
        },
        {
          path: 'mp/card/company-video',
          name: 'mp-card-company-video',
          component: MpHomeVideoManage,
          meta: {
            title: '企业视频',
            videoModule: 'CARD_COMPANY',
            videoSingleton: true,
          },
        },
        { path: 'content/intent', name: 'content-intent', component: IntentManage, meta: { title: '意向客户' } },
        { path: 'content/news', name: 'content-news', component: NewsManage, meta: { title: '动态管理' } },
        {
          path: 'content/case-category',
          name: 'content-case-category',
          component: CaseCategoryManage,
          meta: { title: '案例分类' },
        },
        {
          path: 'content/trust-section',
          name: 'content-trust-section',
          component: TrustSectionManage,
          meta: { title: '信任模块' },
        },
        {
          path: 'content/site-config',
          name: 'content-site-config',
          component: SiteConfigManage,
          meta: { title: '全局配置' },
        },
        {
          path: 'content/home-banner',
          name: 'content-home-banner',
          component: HomeBannerManage,
          meta: { title: 'Banner 管理' },
        },
        {
          path: 'content/about-page',
          name: 'content-about-page',
          component: AboutPageManage,
          meta: { title: '关于页管理' },
        },
        {
          path: 'content/booth-prompt',
          name: 'content-booth-prompt',
          component: () => import('../views/content/booth-prompt/index.vue'),
          meta: { title: '展台提示词' },
        },
        {
          path: 'content/tenant-card',
          name: 'content-tenant-card',
          component: () => import('../views/content/tenant-card/index.vue'),
          meta: { title: '租户云名片' },
        },
        {
          path: 'content/tenant-card/:id/config',
          name: 'content-tenant-card-config',
          component: () => import('../views/content/tenant-card/config.vue'),
          meta: { title: '租户配置' },
        },
        { path: 'chat/faq', name: 'chat-faq', component: ChatFaqManage, meta: { title: '问答管理' } },
        {
          path: 'chat/session',
          name: 'chat-session',
          component: ChatSessionManage,
          meta: { title: '会话记录' },
        },
        { path: 'chat/lead', name: 'chat-lead', component: ChatLeadManage, meta: { title: '聊天线索' } },
        {
          path: 'chat/settings',
          name: 'chat-settings',
          component: ChatSettingsManage,
          meta: { title: '欢迎与快捷问题' },
        },
        {
          path: 'chat/unmatched',
          name: 'chat-unmatched',
          component: ChatUnmatchedManage,
          meta: { title: '未命中统计' },
        },
        {
          path: 'chat/agent',
          name: 'chat-agent',
          component: ChatAgentDesk,
          meta: { title: '人工客服工作台' },
        },
        {
          path: 'chat/intent-rule',
          name: 'chat-intent-rule',
          component: ChatIntentRuleManage,
          meta: { title: '意向规则' },
        },
        {
          path: 'exhibitor/exhibition',
          name: 'exhibitor-exhibition',
          component: ExhibitorExhibitionManage,
          meta: { title: '展会标签' },
        },
        {
          path: 'exhibitor/list',
          name: 'exhibitor-list',
          component: ExhibitorListManage,
          meta: { title: '展商信息' },
        },
        {
          path: 'exhibitor/detail/:id',
          name: 'exhibitor-detail',
          component: ExhibitorDetail,
          meta: { title: '展商详情' },
        },
        {
          path: 'exhibitor/communication',
          name: 'exhibitor-communication',
          component: ExhibitorCommunicationManage,
          meta: { title: '沟通记录' },
        },
        {
          path: 'mp/home/video',
          name: 'mp-home-video',
          component: MpHomeVideoManage,
          meta: {
            title: '视频管理',
            videoModule: 'HOME_BANNER',
            videoSingleton: false,
          },
        },
        {
          path: 'mp/home/service-scope',
          name: 'mp-home-service-scope',
          component: MpHomeServiceScope,
          meta: { title: '服务范围' },
        },
        { path: 'mp/home/news', name: 'mp-home-news', component: MpHomeNews, meta: { title: '行业资讯' } },
        {
          path: 'mp/home/clients',
          name: 'mp-home-clients',
          component: MpHomeClientsManage,
          meta: { title: '服务客户' },
        },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.ensureReady()
  const needAuth = to.matched.some((r) => r.meta.requiresAuth)
  if (needAuth && !auth.token) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'login' && auth.token) {
    return { name: 'dashboard' }
  }
  return true
})

router.afterEach((to) => {
  const pageTitle = to.meta.title
  document.title = pageTitle ? `${pageTitle} - ${APP_TITLE}` : APP_TITLE
})

export default router
